import TableBody from "@mui/material/TableBody";

import Colors from "@src/constants/Colors";
import { Skeleton } from "@mui/material";
import { TABLE_ROW_COUNT, ErrorState } from "@src/constants";
import { Column, RowData } from "../DataTable/types";
import Ellipsis from "../Ellipsis";
import { StyledBodyTableCell, StyledTableRow, StyledTypography } from "./style";
import { Flex } from "../Flex";

interface CustomTableBodyTypes {
  dyColumns: Column[];
  showPagination: boolean;
  rowData: RowData[];
  convertLink: (label: string, row: RowData, column?: Column) => JSX.Element;
  addAlert: (label: string, isOvertime: boolean) => JSX.Element;
  loading: boolean;
  isDesktop: boolean;
}

const CustomTableBody = ({
  rowData,
  showPagination,
  dyColumns,
  convertLink,
  addAlert,
  loading,
  isDesktop,
}: CustomTableBodyTypes) => {
  const formatValue = (
    row: RowData,
    column: Column,
    value: string | number | undefined
  ) => {
    if (value === "" || value === undefined || value === null)
      return <ErrorState />;
    if (column.link && !column.format) {
      return convertLink(String(value), row, column);
    }
    if (row.overtime && column.alert) {
      return addAlert(String(value), row.overtime);
    }
    if (column.format) {
      return <Flex alignItems="center">{column.format(Number(value))}</Flex>;
    }
    if (!row.overtime && column.alert) {
      return (
        <StyledTypography>
          <Flex alignItems="center">
            <Ellipsis width={column.minWidth} isTooltip={column.showTooltip}>
              {value}
            </Ellipsis>
          </Flex>
        </StyledTypography>
      );
    }
    return (
      <Flex alignItems="center">
        <Ellipsis width={column.minWidth} isTooltip={column.showTooltip}>
          {value}
        </Ellipsis>
      </Flex>
    );
  };

  return (
    <TableBody>
      {rowData?.length > 0 &&
        rowData?.slice(0, showPagination ? TABLE_ROW_COUNT : 5)?.map((row) => {
          return (
            <StyledTableRow
              hover
              role="checkbox"
              tabIndex={-1}
              key={Math.random()}
            >
              {dyColumns?.map((column: Column) => {
                const value = row[column.id];
                return (
                  <StyledBodyTableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: column.minWidth,
                      position: column.freeze ? "sticky" : "unset",
                      left: column.freeze ? 0 : "auto",
                      backgroundColor: Colors.white,
                      borderRight: isDesktop
                        ? `1px solid ${Colors.neutral_gray_300}`
                        : "",
                    }}
                  >
                    {loading ? <Skeleton /> : formatValue(row, column, value)}
                  </StyledBodyTableCell>
                );
              })}
            </StyledTableRow>
          );
        })}
    </TableBody>
  );
};

export default CustomTableBody;
